import { MarkerType } from '@xyflow/react';
import { cardColor } from 'managerialTree/colorVariant';

const getNodeColor = (departmentName) => {
    const colors = cardColor[departmentName] || cardColor['Staff'];
    return colors.border;
};

export const buildATree = (empData) => {
    let map = new Map();

    empData.forEach((emp) => {
        if (emp.userId === 'zahid.hossain@echologyx.com') {
            map.set(emp.userId, { ...emp, subordinates: [], expanded: true });
        } else {
            map.set(emp.userId, { ...emp, subordinates: [], expanded: false });
        }
    });

    let roots = [];
    empData.forEach((emp) => {
        const manager = map.get(emp.reportingManager);
        if (manager) {
            manager.subordinates.push(map.get(emp.userId));
        } else {
            roots.push(map.get(emp.userId));
        }
    });

    return roots;
};

// Function to generate only visible nodes and edges
export function generateVisibleFlow(
    treeRoot,
    onToggleExpand,
    onNodeClickHandler,
    config = {}
) {
    const spacingX = config.spacingX || 300;
    const spacingY = config.spacingY || 300;

    const nodes = [];
    const edges = [];

    function layout(node, depth = 0, offsetX = config.offsetX || 0) {
        const nodeId = node.userId;
        let x = offsetX;
        let y = depth * spacingY;

        nodes.push({
            id: nodeId,
            data: {
                ...node,
                onToggleExpand,
                onNodeClickHandler
            },
            position: { x, y },
            type: 'customNode'
        });

        if (!node.expanded || !node.subordinates?.length) return 1;

        let totalSubtreeWidth = 0;
        let childOffsetX = offsetX;

        node.subordinates.forEach((child) => {
            const childWidth = layout(child, depth + 1, childOffsetX);
            childOffsetX += childWidth * spacingX;
            totalSubtreeWidth += childWidth;

            const edgeColor = getNodeColor(child.departmentName);
            edges.push({
                id: `${nodeId}-${child.userId}`,
                source: nodeId,
                target: child.userId,
                type: 'step',
                markerEnd: {
                    type: MarkerType.ArrowClosed,
                    color: edgeColor
                },
                style: {
                    stroke: edgeColor,
                    strokeWidth: 2
                }
            });
        });

        // Center the parent
        const currentNode = nodes.find((n) => n.id === nodeId);
        currentNode.position.x =
            offsetX + (totalSubtreeWidth * spacingX - spacingX) / 2;

        return totalSubtreeWidth;
    }

    layout(treeRoot, 0, config.offsetX || 0);
    return { nodes, edges };
}

export function getTreeWidth(nodes) {
    if (nodes.length === 0) return 0;
    const xPositions = nodes.map((n) => n.position.x);
    const minX = Math.min(...xPositions);
    const maxX = Math.max(...xPositions);
    return maxX - minX;
}

export function expandPathToNode(tree, targetId) {
    // Deep clone the tree to avoid mutating the original state
    const cloneTree = (node) => ({
        ...node,
        subordinates: node.subordinates?.map(cloneTree) || []
    });

    const clonedTree = tree.map(cloneTree);

    const dfs = (node) => {
        if (node.userId === targetId) {
            return true;
        }

        for (const child of node.subordinates || []) {
            const found = dfs(child);
            if (found) {
                node.expanded = true;
                return true;
            }
        }

        return false;
    };

    for (const root of clonedTree) {
        dfs(root);
    }

    return clonedTree;
}
